// extracted by mini-css-extract-plugin
module.exports = {"arrowColor":"#006ebc","bodyreset":"button_bodyreset__2YhqF","button":"button_button__2iTB1","buttonPlaceholder":"button_buttonPlaceholder__3lm1U"};